import type { VoidFunctionComponent } from 'react';

import { getQualityFilterVersionString } from '../../../helpers/policies';
import Button from '../../generic/Button';
import List from '../../generic/List';
import type { QualityRule } from '../../../types';

type Props = {
  rules: Array<Partial<QualityRule>>;
  onAddRule: () => void;
  removeRule: (index: number) => void;
};

const ComponentFilterTable: VoidFunctionComponent<Props> = ({ rules, onAddRule, removeRule }) => (
  <List>
    <List.Header>
      <List.HeaderText>Rules</List.HeaderText>
      <Button size="small" type="secondary" onClick={onAddRule}>
        Add Rule
      </Button>
    </List.Header>
    <List.Body>
      {rules.length === 0 ? (
        <List.Row isInteractive={false}>
          <List.RowTitle>No rules to display.</List.RowTitle>
        </List.Row>
      ) : (
        rules.map((rule, i) => (
          <List.RowContainer key={rule.ruleId ?? i}>
            <List.Row
              isInteractive={false}
              right={
                <Button size="small" type="error" onClick={() => removeRule(i)}>
                  Remove
                </Button>
              }
            >
              <List.RowTitle>
                {rule.dependencyFilterName || rule.packageProjectLocator}
              </List.RowTitle>
              <List.RowDetails>
                <List.RowDetailsItem>
                  {getQualityFilterVersionString(
                    rule.dependencyFilterVersionType ?? 'ALL',
                    rule.dependencyFilterStartVersion ?? '',
                    rule.dependencyFilterEndVersion ?? '',
                  )}
                </List.RowDetailsItem>
              </List.RowDetails>
            </List.Row>
          </List.RowContainer>
        ))
      )}
    </List.Body>
  </List>
);

export default ComponentFilterTable;
